// FILE: frontend/src/components/TestPanel.jsx
// Placement test panel showing current level and score history

import React from 'react'
import ScoreBar from './ScoreBar'

export default function TestPanel({ placedLevel, testScores }) {
  const latest = testScores.length ? testScores[testScores.length - 1] : null
  const avg = testScores.length > 0
    ? (testScores.reduce((s, x) => s + Number(x.overall || 0), 0) / testScores.length).toFixed(1)
    : '0.0'

  return (
    <div className="sqa-test-panel">
      <h3>Placement Test</h3>

      <div style={{ textAlign: 'center', margin: '16px 0' }}>
        <div className="score-num" style={{ fontSize: 36 }}>
          {placedLevel || '—'}
        </div>
        <div style={{ fontSize: 11, color: 'var(--gray-400)', marginTop: 4 }}>
          {placedLevel ? `Current placement: ${placedLevel}` : 'Placement not decided yet.'}
        </div>
      </div>

      <div style={{ display: 'flex', gap: 16, marginBottom: 16 }}>
        <div style={{ flex: 1, textAlign: 'center' }}>
          <div style={{ fontWeight: 600, fontSize: 18, color: 'var(--purple)' }}>{testScores.length}</div>
          <div style={{ fontSize: 10, color: 'var(--gray-400)', textTransform: 'uppercase' }}>Questions</div>
        </div>
        <div style={{ flex: 1, textAlign: 'center' }}>
          <div style={{ fontWeight: 600, fontSize: 18, color: 'var(--purple)' }}>{avg}</div>
          <div style={{ fontSize: 10, color: 'var(--gray-400)', textTransform: 'uppercase' }}>Avg Score</div>
        </div>
      </div>

      {latest && (
        <div>
          <h3 style={{ marginBottom: 8 }}>Latest Evaluation</h3>
          <div className="score-bars">
            <ScoreBar label="Overall" value={latest.overall} />
            <ScoreBar label="Fluency" value={latest.fluency} />
            <ScoreBar label="Completeness" value={latest.completeness} />
            <ScoreBar label="Vocabulary" value={latest.vocabulary} />
            <ScoreBar label="Grammar" value={latest.grammar} />
          </div>
          {latest.feedback && (
            <div className="score-tip" style={{ marginTop: 10 }}>
              {latest.feedback}
            </div>
          )}
        </div>
      )}
    </div>
  )
}
